import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";

import logo from "../../images/logomenu.png";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

const Header = (props) => {
  const { history } = props;

  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (PageURL) => {
    history.push(PageURL);
    setAnchorElNav(null);
  };

  return (
    <AppBar position="static" style={{ boxShadow: "none" }}>
      <div className="menu">
        <Container>
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 7, mr: 2, display: { xs: "none", md: "flex" } }}
            >
              <Link style={{ textDecoration: "none" }} to="/">
                <img className="QL---Header---LOGOIMG" src={logo} alt="image" />
              </Link>
            </Typography>

            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            ></Typography>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
              <Link style={{ textDecoration: "none" }} to="/">
                <img className="img pb-3" src={logo} alt="image" />
              </Link>
            </Typography>

            <Box
              sx={{
                justifyContent: "space-between",
                flexGrow: 1,
                color: "black",
                display: { xs: "none", md: "flex" },
              }}
            >
              <MenuItem onClick={() => handleCloseNavMenu("/")}>Home </MenuItem>
              <MenuItem onClick={() => handleCloseNavMenu("/AboutUs")}>
                About us
              </MenuItem>
              <MenuItem onClick={() => handleCloseNavMenu("/Courses")}>
                Courses
              </MenuItem>
              <MenuItem onClick={() => handleCloseNavMenu("/Pricing")}>
                Pricing
              </MenuItem>
              <MenuItem onClick={() => handleCloseNavMenu("/Contact")}>
                Contact
              </MenuItem>
              <div className="QL__HEader__button">
                <Link style={{ textDecoration: "none" }} to="/Registration">
                  <Button
                    style={{ mrginright: 12 }}
                    className="Allbuttons"
                    variant="contained"
                  >
                    Register now
                  </Button>
                </Link>
              </div>
            </Box>

            <Box sx={{ flexGrow: 0, display: { xs: "flex", md: "none" } }}>
              <IconButton
                style={{ color: "black" }}
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                <MenuItem onClick={() => handleCloseNavMenu("/")}>
                  Home
                </MenuItem>
                <MenuItem onClick={() => handleCloseNavMenu("/AboutUs")}>
                  About Us
                </MenuItem>
                <MenuItem onClick={() => handleCloseNavMenu("/Courses")}>
                  Courses
                </MenuItem>
                <MenuItem onClick={() => handleCloseNavMenu("/Pricing")}>
                  Pricing
                </MenuItem>
                <MenuItem onClick={() => handleCloseNavMenu("/Contact")}>
                  Contact
                </MenuItem>
                <MenuItem onClick={() => handleCloseNavMenu("/Registration")}>
                  Register now
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </div>
    </AppBar>
  );
};
export default withRouter(Header);
